import api from "./api";
import { ApiResponse } from "../types";

export type PerfilUsuario = "Admin" | "Editor" | "Visualizador";

export interface UsuarioSistema {
  id: string;
  nome?: string | null;
  email: string;
  avatarUrl?: string | null;
  perfil: PerfilUsuario;
  ativo: boolean;
  ultimoAcesso?: string | null;
  createdAt: string;
}

/** Gestão de usuários. A API só responde a quem tem perfil Admin. */
export const usuarioService = {
  async listar(): Promise<UsuarioSistema[]> {
    const r = await api.get<ApiResponse<UsuarioSistema[]>>("/painel/usuarios");
    if (!r.data.success || !r.data.data) {
      throw new Error(r.data.message || "Erro ao carregar usuários");
    }
    return r.data.data;
  },

  async alterarPerfil(id: string, perfil: PerfilUsuario): Promise<void> {
    const r = await api.put<ApiResponse<unknown>>(
      `/painel/usuarios/${id}/perfil`,
      { perfil },
    );
    if (!r.data.success) {
      throw new Error(r.data.message || "Erro ao alterar o perfil");
    }
  },
};
